<template>

	<Teleport to="body">
		<div class='website-chat-modal-container' ref="modalWindow">
			<div class='general-modal-header-container'>
				<div>网页对话</div>
				<img class="general-modal-header-close-btn" src="../images/close_white.svg" alt="close"
				     @click="this.onClose">
			</div>
			<div class="topic-detail-container">
				<div class='topic-title'>指纹：{{ this.chatItem?.fp }}</div>


				<div class='topic-conversation'>对话：<br></div>
				<template v-for="(item) in this.chatList" :key="item.chatId">
					<div class="cs-chat-content-wrapper">
						<div
							:class="[item.type === 'customer' ? 'cs-topic-detail-client-chat' : 'cs-topic-detail-cs-chat']"
							style="width: 100%;text-align: start;">
							<div class="chat-box-header">
								<div class="chat-box-talker-container">
									{{ (item.type === 'customer' ? '用户：\n' : '我：\n') }}
								</div>
								<!--									<img src="../images/delete_chat.svg" alt="close topic" v-if="item.role !== 'client'"-->
								<!--									     style="width: 1.2em;cursor: pointer;">-->
							</div>
							<!-- 插值紧贴标签写：上面那条 white-space: pre-wrap 会把模板里的换行和缩进
							     也当成内容渲染出来，气泡上下就会多出空行、每行前面还带一截缩进 -->
							<div
								:class="[item.type === 'customer' ? 'chat-box-client-msg-container' : 'chat-box-my-msg-container']"
								v-if="item.msg"
							>{{ item.msg }}</div>
							<img :src="item.image"
							     :class="[item.type === 'customer' ? 'chat-box-client-img-container' : 'chat-box-my-img-container']"
							     v-if="item.image"/>


							<div style="width: 100%;text-align: right;">{{ item.createTimeString }}</div>
						</div>
					</div>
				</template>

				<!-- AI 生成的待审批回复。放在对话最末尾，位置和它将来发出去之后一样，
				     这样管理员看到的顺序就是用户将来看到的顺序 -->
				<div class="agent-reply-card" v-if="this.pendingReply">
					<div class="agent-reply-header">
						<span class="agent-reply-tag">待审批的 AI 回复</span>
						<span class="agent-reply-meta" v-if="this.pendingReply.createdTimeString">
							{{ this.pendingReply.createdTimeString }}
						</span>
					</div>

					<textarea class="agent-reply-editor" rows="5" v-if="this.isEditingReply"
					          v-model="this.editingContent"/>
					<div class="agent-reply-content" v-else>{{ this.pendingReply.replyContent }}</div>

					<div class="agent-reply-btn-container">
						<template v-if="this.isEditingReply">
							<div class="agent-reply-btn is-approve" @click="onApproveAgentReply(true)">保存并发送</div>
							<div class="agent-reply-btn is-edit" @click="onCancelEditAgentReply">取消编辑</div>
						</template>
						<template v-else>
							<div class="agent-reply-btn is-approve" @click="onApproveAgentReply(false)">同意回复</div>
							<div class="agent-reply-btn is-reject" @click="onRejectAgentReply">驳回</div>
							<div class="agent-reply-btn is-edit" @click="onEditAgentReply">编辑</div>
						</template>
					</div>
				</div>
			</div>

			<div class="editor-container">
					<textarea class='cs-input' type="text" placeholder='请在此输入信息' rows="3"
					          v-model="this.toSendMsg"/>
				<div class="editor-btn-container">
					<a-button type="primary" size="middle" @click="sendMsg"
					          style="color: #191123FF;background-color: #FF8900;margin-left: 0.2em;margin-bottom: 0.2em;">
						发送
					</a-button>
					<!--					<a-button type="primary" size="middle" @click="sendMsgReply"-->
					<!--					          style="color: #191123FF;background-color: #FF8900;margin-left: 0.2em;">-->
					<!--						<img src="../images/attachment.svg" alt="attachment">-->
					<!--					</a-button>-->
				</div>

			</div>
		</div>
	</Teleport>

</template>
<script>

import {hideLoading, postRequestAsync, showLoading, getFingerprint} from "@/utils/methods";

export default {
	name: "WebsiteChatDetailModal",
	data() {
		return {
			chatList: [],
			toSendMsg: '',
			// AI 生成、等管理员点头的那条回复。没有就是 null，卡片不显示
			pendingReply: null,
			isEditingReply: false,
			editingContent: '',
			isApproving: false
		}
	},
	props: {
		chatItem: {
			type: Object,
			required: true,
			isTouched: false
		}
	},
	inject: ['isMobile'],
	async mounted() {
		await this.getWebsiteChatList()
		if (this.isMobile) {
			this.setHeight()
			setTimeout(() => {
				this.setHeight()
			}, 1000)
			setTimeout(() => {
				this.setHeight()
			}, 2000)
		}
	},
	methods: {
		onClose() {
			this.$emit('close')
		},
		async sendMsg() {
			if (!this.toSendMsg) {
				return
			}
			showLoading()
			const fp = this.chatItem?.fp
			const result = await postRequestAsync('admin/cs/replyWebsiteChat', {fp: fp, msg: this.toSendMsg})
			hideLoading()
			if (result?.code === 200 && result?.msg?.list) {
				this.chatList = result?.msg?.list
				this.toSendMsg = ''
				// 人工已经回过了，这个会话转成已回复，那张 AI 审批卡片就不该再留着
				await this.getPendingAgentReply()
			}
			this.$emit('msgSent')
		},
		async getWebsiteChatList() {
			showLoading()
			const fp = this.chatItem?.fp
			const result = await postRequestAsync('admin/cs/getWebsiteChatByFp', {fp: fp})
			hideLoading()
			if (result?.code === 200 && result?.msg?.list) {
				this.chatList = result?.msg?.list

			}
			await this.getPendingAgentReply()
		},
		/**
		 * 拉这个会话上待审批的 AI 回复。
		 *
		 * 不看会话的已回复标记而是直接问有没有待审批记录：回复一旦发出去，记录就被标成
		 * 已审批、这里自然查不到了，所以"有记录"本身就等价于"还等着回复"。
		 *
		 * 失败不弹错：这只是详情上的一块附加内容，为它打断看对话不值当。
		 */
		async getPendingAgentReply() {
			if (!this.chatItem?.fp) {
				return
			}
			const result = await postRequestAsync('admin/cs/getPendingAgentReply', {
				messageType: 'web',
				// 用户的指纹，和请求头里管理员自己那个 fp 不是一回事
				chatFp: this.chatItem?.fp
			})
			this.pendingReply = result?.code === 200 ? (result?.msg?.pendingReply || null) : null
			this.isEditingReply = false
			this.editingContent = ''
		},
		onEditAgentReply() {
			this.editingContent = this.pendingReply?.replyContent || ''
			this.isEditingReply = true
		},
		onCancelEditAgentReply() {
			this.isEditingReply = false
			this.editingContent = ''
		},
		/**
		 * 同意并发送。
		 *
		 * @param withEdit 是否把编辑框里改过的内容一起发出去。
		 *        改过的内容后端会存回记录，发出去的和存档的始终是同一份。
		 */
		async onApproveAgentReply(withEdit) {
			if (!this.pendingReply || this.isApproving) {
				return
			}
			const replyContent = withEdit ? (this.editingContent || '').trim() : ''
			if (withEdit && !replyContent) {
				this.$message.error('回复内容不能为空')
				return
			}

			this.isApproving = true
			showLoading()
			try {
				const result = await postRequestAsync('admin/cs/approveAgentReply', {
					agentReplyRecordId: this.pendingReply.agentReplyRecordId,
					isApprove: true,
					replyContent: withEdit ? replyContent : undefined
				})
				if (result?.code === 200) {
					this.pendingReply = null
					this.isEditingReply = false
					this.$message.success('已发送给用户')
					// 发出去的回复现在是对话里的一条正式记录，重新拉一遍
					await this.getWebsiteChatList()
					this.$emit('msgSent')
				} else if (result?.code === 304) {
					this.$message.warning('这条回复已经被处理过了')
					await this.getPendingAgentReply()
				} else {
					this.$message.error(`操作失败${result?.code ? `（${result.code}）` : ''}`)
				}
			} finally {
				this.isApproving = false
				hideLoading()
			}
		},
		/**
		 * 驳回：只把记录标成已处理，不发给用户。
		 */
		async onRejectAgentReply() {
			if (!this.pendingReply || this.isApproving) {
				return
			}
			this.isApproving = true
			showLoading()
			try {
				const result = await postRequestAsync('admin/cs/approveAgentReply', {
					agentReplyRecordId: this.pendingReply.agentReplyRecordId,
					isApprove: false
				})
				if (result?.code === 200 || result?.code === 304) {
					this.pendingReply = null
					this.isEditingReply = false
					this.$message.success('已驳回，未发送给用户')
				} else {
					this.$message.error(`操作失败${result?.code ? `（${result.code}）` : ''}`)
				}
			} finally {
				this.isApproving = false
				hideLoading()
			}
		},
		onTouchStart(e) {
			e.preventDefault();
			this.isTouched = true;
			// 处理逻辑
			setTimeout(() => {
				this.isTouched = false;
			}, 300); // 300ms后重置
		},
		onClick(e) {
			// 如果是触摸触发的，则不再执行click事件
			if (this.isTouched) return;
			// 处理点击逻辑
		},
		setHeight() {
			this.windowHeight = window.innerHeight
			if (this.$refs.modalWindow) {
				this.$refs.modalWindow.style.height = `${this.windowHeight}px`
			}
		}
	}
}
</script>

<style scoped>

/* 待审批的 AI 回复。用虚线框和普通对话气泡区分开——
   它还没发出去，不能看着像已经在对话里的一条 */
.agent-reply-card {
	box-sizing: border-box;
	width: 100%;
	margin: 0.6em 0 1em 0;
	padding: 0.8em;
	border: 1px dashed #FF8900;
	border-radius: 0.4em;
	background-color: rgba(255, 137, 0, 0.06);
	text-align: left;
}

.agent-reply-header {
	display: flex;
	flex-direction: row;
	align-items: center;
	flex-wrap: wrap;
	gap: 0.5em;
	margin-bottom: 0.5em;
}

.agent-reply-tag {
	color: #191123;
	background-color: #FF8900;
	font-size: 0.9em;
	padding: 0.1em 0.5em;
	border-radius: 0.3em;
	white-space: nowrap;
}

.agent-reply-meta {
	color: rgba(230, 213, 184, 0.5);
	font-size: 0.85em;
}

/* 回复里的换行是有意义的，别被折叠掉 */
.agent-reply-content {
	color: #E6D5B8;
	white-space: pre-wrap;
	word-break: break-word;
	line-height: 1.5em;
}

.agent-reply-editor {
	box-sizing: border-box;
	width: 100%;
	color: #E6D5B8;
	background-color: rgba(0, 0, 0, 0.3);
	border: 1px solid rgba(230, 213, 184, 0.6);
	border-radius: 0.3em;
	/* App.vue 里有全局的 input/textarea 内边距重置，不加 !important 撑不开 */
	padding: 0.5em !important;
	line-height: 1.5em;
	outline: none;
	resize: vertical;
}

.agent-reply-editor:focus {
	border-color: #FF8900;
}

.agent-reply-btn-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	flex-wrap: wrap;
	justify-content: flex-end;
	gap: 0.5em;
	margin-top: 0.6em;
}

.agent-reply-btn {
	color: #191123;
	font-size: 0.9em;
	padding: 0.3em 0.9em;
	border: 1px solid transparent;
	border-radius: 0.3em;
	cursor: pointer;
	white-space: nowrap;
}

.agent-reply-btn.is-approve {
	background-color: #52c41a;
	border-color: #52c41a;
}

.agent-reply-btn.is-reject {
	background-color: #ff6b6b;
	border-color: #ff6b6b;
}

/* 编辑不改变任何数据，做成描边的次要按钮，和另外两个拉开轻重 */
.agent-reply-btn.is-edit {
	color: #FF8900;
	background-color: transparent;
	border-color: #FF8900;
}

.modal-bg {
	position: fixed;
	width: 100vw;
	height: 100vh;
	/*backdrop-filter: blur(8px) opacity(100%) brightness(90%);*/
	z-index: 1000;
	background-color: rgba(0, 0, 0, 0.3);
	top: 0;
	left: 0;
	backdrop-filter: blur(4px) opacity(100%) brightness(90%);
	pointer-events: auto;
	touch-action: none;
}

@media (max-width: 900px) {
	.website-chat-modal-container {
		width: 100% !important;
		top: 0;
		left: 0;
	}

}

@media (min-width:900px) {
	.website-chat-modal-container {
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		max-height: 80%;
		min-width: 40em;
	}
}

.website-chat-modal-container {
	position: fixed;
	background-color: #1f1f35;
	overflow-y: hidden;
	display: flex;
	flex-direction: column;
	padding: 0.4em;
	box-sizing: border-box;
	overflow-x: hidden;
}

.topic-title {
	width: 100%;
	font-size: 1.2em;
	color: #E6D5B8;
	text-align: start;
	word-wrap: break-word;
}

.topic-type {
	width: fit-content;
	font-size: 1.2em;
	color: #E6D5B8;
	text-align: start;
	word-wrap: break-word;
	display: flex;
	flex-direction: row;
	align-items: center;
}

.topic-email {
	width: 100%;
	font-size: 1.2em;
	color: rgba(230, 213, 184, 0.8);
	text-align: start;
}

.user-detail {
	width: 100%;
	font-size: 1.2em;
	color: #E6D5B8;
	text-align: start;
	display: flex;
	flex-direction: row;
}

.user-detail-container {
	display: flex;
	font-size: 1.2em;
	line-height: 1.2em;
	flex-direction: column;
	width: 100%;
	color: #E6D5B8;
	align-items: start;
	background-color: rgba(230, 213, 184, 0.2);
	padding: 0.2em;
	box-sizing: border-box;
	border-radius: 0.2em;
}

.topic-conversation {
	width: 100%;
	font-size: 1.2em;
	color: #E6D5B8;
	text-align: start;
}

.cs-topic-detail-client-chat {
	background-color: rgba(255, 137, 0, 0.2);
	color: #FF8900;
	padding: 0.4em;
	border-radius: 0.4em;
	margin: 0.4em 0;
	width: fit-content;
	box-sizing: border-box;
}

.cs-topic-detail-cs-chat {
	background-color: rgba(230, 213, 184, 0.2);
	color: #E6D5B8;
	padding: 0.4em;
	border-radius: 0.4em;
	margin: 0.4em 0;
	width: fit-content;
	box-sizing: border-box;
}

.editor-container {
	bottom: 0;
	left: 0;
	display: flex;
	flex-direction: row;
	justify-content: center;
	width: 100%;
	padding: 0.2em 0.2em 2em 0.2em;
	align-items: flex-start;
	background-color: #1f1f35;
}

textarea {

	background-color: transparent;
	border: 1px solid #FF8900;
	border-radius: 0.2em;
	flex: 1;
	color: #FF8900;
	font-size: 1.2em;
	min-height: calc(3 * 1.4em); /* 最少3行 */
	max-height: calc(10 * 1.4em); /* 最多10行 */
	line-height: 1.4em;
	overflow-y: auto;
	resize: vertical;
	padding: 5px;
	box-sizing: border-box;
}

textarea:focus {
	border: 1px solid #FF8900;
}

textarea:focus-visible {
	outline: #ffad50 auto 1px;
}

/* 其他浏览器 */
textarea::placeholder {
	color: #c76c00;
}

.editor-btn-container {
	display: flex;
	flex-direction: column;
}

.topic-detail-container {
	display: flex;
	flex-direction: column;
	overflow-y: auto;
	overflow-x: hidden;
	flex: 1;
}

.chat-box-header {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.chat-box-client-msg-container {
	color: #FF8900;
	word-wrap: break-word;
	/* 消息里的换行和缩进是内容的一部分（AI 回复带列表、用户贴日志），
	   HTML 默认会把它们折叠成一个空格，整段挤成一坨 */
	white-space: pre-wrap;
}

.chat-box-client-img-container {
	max-width: 50%;
}

.chat-box-my-img-container {
	max-width: 50%;
}

.chat-box-my-msg-container {
	color: #E6D5B8;
	word-wrap: break-word;
	white-space: pre-wrap;
}

.topic-type-container {
	display: flex;
	flex-direction: column;
	border: 1px solid #E6D5B8;
	padding: 0.2em;
	border-radius: 0.2em;
}

.topic-type-label {
	word-break: keep-all;
	white-space: nowrap;
	color: rgba(230, 213, 184, 0.8);
	line-height: 1.2em;
}

.ticket-img {
	width: 100%;
	font-size: 1.2em;
	color: #E6D5B8;
	text-align: start;
	display: flex;
	flex-direction: row;
}

.device-info-label {
	width: 100%;
	font-size: 1.2em;
	color: #E6D5B8;
	text-align: start;
	display: flex;
	flex-direction: row;
}

.ticket-img-container {
	display: flex;
	flex-direction: row;
	cursor: pointer;
}

.ticket-img-wrapper {
	width: 5em;
	height: 5em;
	background-color: #000;
	padding: 0.2em;
	box-sizing: border-box;
}

.device-info-container {
	display: flex;
	flex-direction: column;
	border: 1px solid rgba(230, 213, 184, 0.5);
	padding: 0.2em;
	border-radius: 0.2em;
	margin: 0.4em 0;
	box-sizing: border-box;
}

.device-info-row {
	display: flex;
	flex-direction: row;
	color: #E6D5B8;
}

.flex-table {
	display: flex;
	flex-direction: column;
	max-width: 800px;
	font-family: Arial, sans-serif;
}

.table-header, .table-row {
	display: flex;
	flex-direction: row;
	border-bottom: 1px solid #E6D5B8;
	width: 100%;
	min-width: 100%;
	box-sizing: border-box;
}

.table-header {
	background-color: rgba(230, 213, 184, 0.3);
	font-weight: bold;
}

.table-cell {
	padding: 0.2em;
	text-align: center;
	/* 关键：添加这些属性确保内容不会撑开单元格 */
	box-sizing: border-box;
	min-width: 0; /* 防止flex项目超出容器 */
	word-wrap: break-word; /* 长文本自动换行 */
	color: #E6D5B8;
}

.table-cell:nth-child(1),
.table-cell:nth-child(2) {
	flex: 0 0 auto; /* 不伸缩，保持内容宽度 */
	white-space: nowrap; /* 防止文本换行 */
}

.table-cell:nth-child(3),
.table-cell:nth-child(4) {
	flex: 1 1 0; /* 可伸缩，平分剩余空间 */
}


</style>